import { FormattedMessage } from 'react-intl'
import { Button } from '..'
import {
  getContactLimitStats,
  isOverContactLimit,
  showUpgradePrompt,
} from '../../utils/planLimits'
import { isAppsumoUser } from '../../utils/appsumoBilling'

export const ContactLimitBanner = ({ entitlements = window?.entitlements }) => {
  if (!isOverContactLimit(entitlements)) return null

  const { used, limit } = getContactLimitStats(entitlements)
  const appsumo = isAppsumoUser(entitlements)

  return (
    <div className="flex flex-wrap items-center justify-center gap-2 bg-amber-50 text-amber-900 text-sm px-3 py-2 w-full border-b border-amber-200">
      <span>
        {appsumo ? (
          <FormattedMessage
            id="appsumo.contact_limit.banner"
            defaultMessage="You've exceeded your AppSumo contact limit ({used}/{limit}). New contacts won't be added and email sending is paused until you're back under the limit. Remove contacts or upgrade your plan."
            values={{ used: used ?? '—', limit: limit ?? '—' }}
          />
        ) : (
          <FormattedMessage
            id="plan.contact_limit.banner"
            defaultMessage="You've exceeded your plan's contact limit ({used}/{limit}). New contacts won't be added and email sending is paused until you're back under the limit. Remove contacts or upgrade your plan."
            values={{ used: used ?? '—', limit: limit ?? '—' }}
          />
        )}
      </span>
      <Button
        action="primary"
        label={appsumo ? 'Upgrade on AppSumo' : 'Upgrade'}
        height={32}
        onClick={() => {
          showUpgradePrompt(entitlements)
        }}
      />
    </div>
  )
}
